<template>
  <div id="admin" :style="{ backgroundImage: 'url(' + require('@/assets/' + image) + ')' }">
    <form @submit.prevent="pressed">
      <h1>RTV Parkstad App - Dashboard</h1>
      <div class="admin__entry-container">
        <label>Gebruikersnaam</label>
        <svg-icon class="admin__entry-container__icon" icon="person" height="14px" width="14px" fill="#FFC500"/>
        <input id="admin__entry-container__username" type="text" placeholder="Typ hier de gebruikersnaam"/>
      </div>
      <div class="admin__entry-container">
        <label>Wachtwoord</label>
        <svg-icon class="admin__entry-container__icon" icon="lock" height="14px" width="14px" fill="#FFC500"/>
        <input id="admin__entry-container__password" type="password" placeholder="Typ hier het wachtwoord"/>
      </div>
      <button class="admin__login-button" type="submit" @click="verifyAdmin">Inloggen</button>
      <div class="admin__error" v-if="error">{{ error.message }}</div>
    </form>
  </div>

  <RealtimeListener v-if="loggedIn"/>
</template>

<script>
import RealtimeListener from "@/components/RealtimeListener.vue";
import SvgIcon from "@/components/SvgIcon.vue";

export default {
  name: "AdminDashboard",
  components: {
    RealtimeListener,
    SvgIcon
  },
  data() {
    return {
      error: "",
      image: "bg-audio.svg",
      loggedIn: false
    };
  },
  mounted() {
    this.showModal();
  },
  methods: {
    showModal() {
      document.getElementById("admin").style.display = "flex";
    },
    closeModal() {
      document.getElementById("admin").style.display = "none";
    },
    verifyAdmin() {
      if (
        document.getElementById("admin__entry-container__username").value ==
          process.env.VUE_APP_MESSAGE_FIRST_CODE &&
        document.getElementById("admin__entry-container__password").value ==
          process.env.VUE_APP_MESSAGE_SECOND_CODE
      ) {
        this.closeModal();
        this.loggedIn = true;
      } else {
        this.error = "Verkeerde login informatie"
      }
    },
  },
};
</script>

<style lang="scss" scoped>
// External Styling
// @import "@/styles/_variables.scss";
//Component Styling
$admin--title-colour: #F55000;
$admin--title-font: "Lato";
$admin--label-colour: #F55000;
$admin--label-font: "Lato";
$admin--input-colour: #959694;
$admin--input-font: "Lato";


#admin {
    width: 100%;
    background-size: cover;
    background-position-y: center;
    padding: 0px 16px !important;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    padding-bottom: 0px !important;
    height: 100vh;
    form {
      background-color: #F9F9F9;
      border-radius: 5px;
      padding: 28px 22px;
      max-width: 328px;
      max-height: 405px;
      margin-top: -50px;
      h1 {
        text-align: center;
        font-size: 22px;
        font-family: $admin--title-font;
        color: $admin--title-colour;
        margin-bottom: 20px;
      }
      .admin__entry-container {
        border-bottom: 1px solid #959694;
        margin-bottom: 12px;
        .admin__entry-container__icon {
          width: 14px;
          margin-top: 6px;
          margin-left: 9px;
          position: absolute;
          z-index: 999;
        }
      }
      label {
        font-family: $admin--label-font;
        color: $admin--label-colour;
        font-weight: bold;
      }
      input {
        width: 100%;
        height: 35px;
        padding-left: 30px;
        box-sizing: border-box;
        background-color: #F9F9F9;
        border: none;
        font-family: $admin--input-font;
        color: $admin--input-colour;
        font-style: italic;
        font-size: 16px;
      }
      .admin__login-button {
        display: block;
        box-sizing: border-box;
        height: 40px;
        max-width: 284px;
        border-radius: 999px;
        border: 0;
        background-color: #FFC500;
        font-size: 19px;
        font-family: $admin--label-font;
        font-weight: bold;
        text-align: center;
        padding: 8px 40px;
        margin: 32px auto 40px;
      }
      .admin__new-user {
        font-family: $admin--label-font;
        font-weight: normal;
        font-size: 14px;
        text-align: center;
        display: block;
        margin: auto;
      }
      .admin__error {
        position: absolute;
        width: 284px;
        color: #D84545;
        display: block;
        margin: -30px auto 10px;
        text-align: center;
      }
    }
}

#listener {

}

/* Smartphones (portrait and landscape) ----------- */

@media only screen and (min-device-width: 320px) and (max-device-width: 599px) {
    #admin {

    }
}

/* Tablet (portrait) ----------- */

@media only screen and (min-device-width: 600px) and (max-device-width: 899px) {
    #admin {

    }
}

/* Tablet (landscape) ----------- */

@media only screen and (min-device-width: 900px) and (max-device-width: 1199px)  {
    #admin {

    }
}

// Desktop versions start here ------------------------------------------------------------------------------------------
/* Desktop ----------- */

@media only screen and (min-device-width: 1200px) and (max-device-width: 1799px)  {
    #admin {

    }
}

/* Large desktop ----------- */

@media only screen and (min-device-width: 1800px)  {
    #admin {

    }
}
</style>